import { stripUnit } from 'polished';
import styled from 'styled-components';
import { Breakpoint, DESKTOP_HEADER_HEIGHT, MOBILE_HEADER_HEIGHT } from '../../styles/constants';
import { TOP_NAVIGATION_BAR_HEIGHT_WITH_HEADER } from '../TopNavigationBar/TopNavigationBar.styles';

type PageContentContainerProps = {
  mobileOffset?: number;
  desktopOffset?: number;
  topNavExperiment?: boolean;
};

const calcContentOffset = (originalValue: string, offset: number = 0) =>
  `${Number(stripUnit(originalValue)) + offset}px`;

export const PageContentContainer = styled.div<PageContentContainerProps>`
  padding-top: ${({ mobileOffset }) => calcContentOffset(MOBILE_HEADER_HEIGHT, mobileOffset)};

  ${Breakpoint.SMALL} {
    padding-top: ${({ desktopOffset }) => calcContentOffset(DESKTOP_HEADER_HEIGHT, desktopOffset)};
  }

  ${Breakpoint.MEDIUM} {
    padding-top: ${({ topNavExperiment, desktopOffset }) =>
      topNavExperiment
        ? calcContentOffset(TOP_NAVIGATION_BAR_HEIGHT_WITH_HEADER, desktopOffset)
        : calcContentOffset(DESKTOP_HEADER_HEIGHT, desktopOffset)};
  }
`;
